import styled from 'styled-components';
import { IconBase } from '../IconBase';


export const InputIcon = styled(IconBase)`
  && {
    color: ${({ theme }) => theme.colours.inputIcon};
  }
`;
